import React from 'react'
import { StyleSheet, css } from 'aphrodite'

import Hidden from '@material-ui/core/Hidden'
// import {Link} from 'react-router-dom';

import TeamMirror from '../../../assets/Team/TeamMirror.png'

export default class SkewBg extends React.Component{

  render(){
    return(
        <section>
            
        <div className={css(styles.mainContainer)}>
            <section className={css(styles.skewIntro)}>
            </section>
            <Hidden smDown>
                <div className={css(styles.mirrorContainer)}>
                    <img className={css(styles.TeamMirror)} src={TeamMirror} alt=""/>
                </div>
            </Hidden>
        </div>
        </section>
    )
  }
}

const styles = StyleSheet.create({
    mainContainer : {
        position: 'relative',
    },
    skewIntro: {
        position: 'absolute',
        zIndex: -1,
        top: 250,
        width: '100vw',
        height: 1500,
        overflow: 'hidden',
        transform: 'skewY(-12deg)',
        transformOrigin: 0,
        background: 'white',
    },
    mirrorContainer: {
        position: 'absolute',
        top: 400,
        right: 0,
        height: 400,
        zIndex: -1
    },
    TeamMirror : {
        height: 'inherit',
        filter: 'drop-shadow(0px 2px 6px rgba(0,21,64,.14)) drop-shadow(0 10px 20px rgba(0,21,64,.14))'
    }
});


// WEBPACK FOOTER //
// ./src/Components/Home/MeetTheTeam/SkewBg.js